<template>
  <modal-wrapper
    ref="modalRef"
    :header="$t('missingFilesModal.title')"
    @ok-button-click="handleModalOK"
  >
    <div v-if="recordsWithoutFile.missingFile.length" class="section-header">
      {{ $t('missingFilesModal.missingFiles') }}:
    </div>
    <ul>
      <li
        v-for="documentId in recordsWithoutFile.missingFile"
        :key="documentId"
      >
        {{ documentId }}
      </li>
    </ul>

    <div
      v-if="recordsWithoutFile.changedMetadata.length"
      class="section-header"
    >
      {{ $t('missingFilesModal.missingFilesWithChangedMetadata') }}:
    </div>
    <ul>
      <li
        v-for="documentId in recordsWithoutFile.changedMetadata"
        :key="documentId"
      >
        {{ documentId }}
      </li>
    </ul>

    <div v-if="recordsWithoutFile.emptyFiles.length" class="section-header">
      {{ $t('missingFilesModal.emptyFiles') }}:
    </div>
    <ul>
      <li v-for="documentId in recordsWithoutFile.emptyFiles" :key="documentId">
        {{ documentId }}
      </li>
    </ul>
  </modal-wrapper>
</template>

<script lang="ts" setup>
  import { RecordsWithoutFile } from '@/components/MassUpload/composables/useMissingFilesChecker.ts';
  import { useModalWrapper } from '../ModalWrapper';

  defineProps<{
    recordsWithoutFile: RecordsWithoutFile;
  }>();

  const emit = defineEmits<{
    (e: 'ignoreMissingFiles'): void;
  }>();

  const { modalRef, show, hide } = useModalWrapper();
  defineExpose({ show, hide });

  function handleModalOK() {
    emit('ignoreMissingFiles');
  }
</script>

<style lang="scss" scoped>
  .section-header {
    font-size: 1.1rem;
    line-height: 1.2;
  }
  ul {
    list-style-type: disc;
    margin-left: 1rem;

    li {
      font-size: 1rem;
    }
    margin-bottom: 0.5rem;
  }
</style>
